import styled from 'styled-components';

import { COLORS, BAR_COLORS, STATUS_COLORS } from '../../theme/tokens';
import { Text } from '../Text/Text';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'accent';

export const TONE_COLOR: Record<BadgeTone, string> = {
  neutral: COLORS.textMuted,
  success: STATUS_COLORS.positive,
  warning: BAR_COLORS.warning,
  danger: STATUS_COLORS.negative,
  accent: COLORS.accent,
};

export const Label = styled(Text)<{ $color: string }>`
  font-size: 14px;
  color: ${(p) => p.$color};
`;
